import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import { selectCompanyInfo } from '../store/slice'
import classes from './index.module.scss'

export const UpdateFS = ({ data, detailKey }) => {
  const { organizationId } = useSelector(selectCompanyInfo)

  const detailData = data[detailKey]

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.description)}
      </Element>
      <Element className={classes.content} style={{ color: '#3A414B' }}>
        <div>{formatText(detailData?.content)}</div>
        <div>
          <Element elementName="span" style={{ color: '#2C73E8' }}>
            <Link
              to={`${COMPONENTS.companyAnalysis.components.financial.components.financialStatements.route}?organizationId=${organizationId}`}
              target="_blank"
            >
              <Translate value="alertDetail.CLICK_HERE" />
            </Link>
          </Element>
          &nbsp;
          <Translate value="alertDetail.FOR_MORE_INFORMATION" />
        </div>
      </Element>
    </Panel>
  )
}
